// Validación reutilizable de rango de fechas (Fecha Inicio/Fin, mismo año).
// Usada por FiltroReporteRefacciones.js y ReporteRefaccionesBoceto.js.
//
// Fecha de creación: 2026-07-10
// Autor: IA (Claude)
export const validarRangoFechas = (fechaInicio, fechaFin) => {
    if (!fechaInicio) {
        return {
            ok: false,
            mensaje: "Favor de seleccionar la fecha de inicio.",
        };
    }
    if (!fechaFin) {
        return {
            ok: false,
            mensaje: "Favor de seleccionar la fecha fin.",
        };
    }
    if (fechaInicio > fechaFin) {
        return {
            ok: false,
            mensaje: "La fecha de inicio no puede ser mayor a la fecha fin.",
        };
    }
    if (fechaInicio.slice(0, 4) !== fechaFin.slice(0, 4)) {
        return {
            ok: false,
            mensaje: "La fecha de inicio y la fecha fin deben ser del mismo año.",
        };
    }
    return { ok: true, mensaje: "" };
};
